import React from "react";
import { Col, Row } from "react-bootstrap";
import { DiNetbeans } from "react-icons/di";
import {
  SiVisualstudiocode,
  SiEclipseide,
  SiPostman,
  SiSlack,
  SiDiscord,
  SiAngular,
  SiIntellijidea,
  SiNetlify,
  SiHibernate,
} from "react-icons/si";

function Toolstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <Col xs={4} md={2} className="tech-icons">
        <SiIntellijidea />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiEclipseide  />
      </Col> 

      <Col xs={4} md={2} className="tech-icons">
        <SiVisualstudiocode />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiPostman />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiSlack />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiDiscord />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiNetlify/>
      </Col>

    </Row>
  );
}

export default Toolstack;
